import React, { useState, useRef } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { Table, Space, Select, Typography } from "antd";
import { UsePostRequest } from "../../utils/api/ApiRequests";
import {
  getIsAdminLogin,
  getEmployeeId,
  minsToHours,
} from "../../utils/Common";
import {
  GetAllBranches,
  GetAllBusinessUnits,
} from "../../utils/api/DropdownFiltersApi";

const { Title } = Typography;
export default function PerformanceEvalutaion() {
  const componentRef = useRef();
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const branchOptions = GetAllBranches();
  const businessUnitOptions = GetAllBusinessUnits();
  const dateFormat = "YYYY-MM-DD";
  const isAdminLogin = getIsAdminLogin();
  const employeeId = getEmployeeId();
  const [searchTerm, setSearchTerm] = useState(null);

  const [filterConfig, setFilterConfig] = useState({
    is_updated: false,
    employee_id: isAdminLogin ? "" : employeeId,
  });

  const tableColumns = [
    {
        title: 'Employee',
        dataIndex: 'employee_name',
        key: 'employee_name',
    },
    {
        title: 'Absent (days)',
        dataIndex: 'absent_count',
        key: 'absent_count',
    },
    {
        title: 'Present (days)',
        dataIndex: 'present_count',
        key: 'present_count',
    },
    {
        title: 'Regular OT (mins)',
        dataIndex: 'regular_ot_mins',
        key: 'regular_ot_mins',
    },
    {
        title: 'Restday OT (mins)',
        dataIndex: 'restday_ot_mins',
        key: 'restday_ot_mins',
    },
    {
        title: 'Late (mins)',
        dataIndex: 'late',
        key: 'late',
    },
    {
        title: 'Undertime (mins)',
        dataIndex: 'undertime_mins',
        key: 'undertime_mins',
    },
  ];

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setFilterConfig((prev) => ({ ...prev, term: searchTerm }));
    }
  };

  const handleDateFilter = (e) => {
    if (e) {
      setFilterConfig((prev) => ({
        ...prev,
        date_from: e[0].format(dateFormat),
        date_to: e[1].format(dateFormat),
      }));
    }
  };

  const handleFilter = (e, field) => {
    setFilterConfig((prev) => ({ ...prev, [field]: e }));
  };

  const handleRowClick = (rowData) => {
    const passValues = {
      id: rowData.employee_id,
      fullname: rowData.employee_name,
      date_from: filterConfig.date_from,
      date_to: filterConfig.date_to,
    };
    navigate("/employees/history-report", { state: passValues });
  };

  const rowProps = (record) => ({
    onClick: () => handleRowClick(record),
  });

  React.useEffect(() => {
    const searchTimeout = setTimeout(() => {
      setFilterConfig((prev) => ({ ...prev, term: searchTerm }));
    }, 2000);

    return () => {
      clearTimeout(searchTimeout);
    };
  }, [searchTerm]);

  React.useEffect(() => {
    async function fetchTableData() {
      setIsFetching(true);
      setTableData([]);
      const response = await UsePostRequest(
        "timesheets/performance_evaluation",
        filterConfig
      );
      if (response.data) {
        setTableData(response.data);
      }
      setIsFetching(false);
    }

    fetchTableData();
  }, [filterConfig]);

  return (
    <Navbar
      pageTitle="Performance Evaluation Report"
      noButton
      withPrintBtn
      printContent={componentRef}
      withDateRangePicker
      onDateChange={handleDateFilter}
      setSearchQuery={(e) => setSearchTerm(e)}
      onSearch={handleSearch}
      searchPlaceholder="employee"
      isManager
      searchable={isAdminLogin}
    >
      {
        isAdminLogin && (
          <Space className="mt-4">
        <Select
          showSearch
          style={{ width: 200 }}
          placeholder="Branch"
          optionFilterProp="items"
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={branchOptions}
          onChange={(e) => handleFilter(e, "branch_id")}
        />
        <Select
          showSearch
          style={{ width: 200 }}
          placeholder="Business Unit"
          optionFilterProp="items"
          filterOption={(input, option) => option.label.includes(input)}
          filterSort={(optionA, optionB) =>
            optionA.label
              .toLowerCase()
              .localeCompare(optionB.label.toLowerCase())
          }
          options={businessUnitOptions}
          onChange={(e) => handleFilter(e, "business_unit_id")}
        />
      </Space>
        )
      }
      <Table
        className={isAdminLogin?'':'mt-4'}
        rowKey="id"
        onRow={(record) => ({
          ...rowProps(record),
          style: { cursor: "pointer" },
        })}
        columns={tableColumns}
        dataSource={tableData}
        loading={isFetching}
      />

      <div className="printOnly">
        <div className="print-report-page" ref={componentRef}>
          <Title level={5} className="px-4">
            PERFORMANCE EVALUATION
          </Title>
          <Table
            className="px-2 mt-3"
            rowKey="id"
            columns={tableColumns}
            dataSource={tableData}
            pagination={false}
          />
        </div>
      </div>
    </Navbar>
  );
}
